import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Notification, STATUS_TYPES } from 'dyl-components';
import importDataActions from 'actions/import_data';
import "./index.scss"

const Results = ({ module, uploadId, getDataMappingValues, checkIsInLoading, recordsCount }) => {

    const dispatch = useDispatch();

    const { import_results, isReadingImportResults } = useSelector(state => state.import_data);

    const [isLoadingResults, setIsLoadingResults] = useState(false);
    const [isFailedToUpload, setIsFailedToUpload] = useState(false);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                if (uploadId) {
                    await dispatch(importDataActions.readImportResults({ upload_id: uploadId }));
                    setIsFailedToUpload(false);
                }
            } catch (e) {
                console.log(e);
                setIsFailedToUpload(true);
                Notification.alert('Failed to add data mappings!**', STATUS_TYPES.ERROR);
            }
        };

        fetchResults();
    }, [uploadId, dispatch]);


    useEffect(() => {
        try {
            const fetchImportResults = async () => {
                if (uploadId && !import_results?.done) {
                    setIsLoadingResults(true);
                    setTimeout(() => {
                        dispatch(importDataActions.readImportResults({ upload_id: uploadId }));
                    }, 10000);
                } else {
                    setIsLoadingResults(false);
                }
            };

            fetchImportResults();

        } catch (error) {
            Notification.alert('Failed to add data mappings!', STATUS_TYPES.ERROR);
        }
    }, [import_results?.done, dispatch, uploadId]);

    return (
        <div className='Results'>
            <h3 className='Results_Header'>Mapping Results</h3>

            {!uploadId && !isFailedToUpload ? <div>
                <b>Successfully added data mappings!</b>
            </div>
                :
                <div>
                    {checkIsInLoading((isLoadingResults || isReadingImportResults) && !isFailedToUpload) ? <p>Mapping in progress...</p> :
                        <>
                            <p><b>New {module === 'Opportunity' ? 'opportunities' : `${module}s`} created:</b> {import_results?.created || 0}</p>
                            <p><b>Duplicates found:</b> {import_results?.duplicates || 0}</p>
                            {getDataMappingValues('group')?.value !== 'none' && <p><b>Added to group/subgroup:</b> {import_results?.group}</p>}
                            {getDataMappingValues('campaign') !== 'none' && <p><b>Added to campaign:</b>  {import_results?.campaign} </p>}
                            {(import_results?.rejected && !isFailedToUpload) ? <>
                                <hr />
                                <p className='Rejected_Records'><b>Rejected records:</b> {import_results?.rejected}</p>
                            </> :
                                <p><b>Rejected records:</b> {0}</p>
                            }
                            {isFailedToUpload ? <>
                                <hr />
                                <p className='Rejected_Records'><b>System failed to upload:</b> {recordsCount}</p>
                            </> : ""}
                        </>
                    }
                </div>
            }

        </div>
    )
}

export default Results;
